import Vue from 'vue'
import {
  Button, Form, FormItem, Input, Message, Container, Aside, Header, Main, Footer, Row, Col, Menu,
  Submenu, MenuItem, Dropdown, DropdownItem, DropdownMenu, MenuItemGroup, Breadcrumb, BreadcrumbItem,
  Card, Table, TableColumn, Pagination, MessageBox, Dialog, Upload, Select, Option, Progress, Alert,
  Checkbox, CheckboxGroup, Descriptions, DescriptionsItem, Result, Notification, Loading, Divider, Tag, Scrollbar, Tree,
  Timeline, TimelineItem, Slider, Tabs, TabPane, ColorPicker, Switch, Backtop,Tooltip,RadioButton,RadioGroup,Radio,Image,Popconfirm
} from 'element-ui'
import divider from "element-ui/packages/divider";
Vue.use(Button);Vue.use(Form);Vue.use(FormItem);Vue.use(Input);Vue.use(Container);
Vue.use(Aside);Vue.use(Header);Vue.use(Main);Vue.use(Footer);Vue.use(Row);Vue.use(Col);
Vue.use(Menu);Vue.use(Submenu);Vue.use(MenuItem);Vue.use(Dropdown);Vue.use(DropdownItem);
Vue.use(DropdownMenu);Vue.use(MenuItemGroup);Vue.use(Breadcrumb);Vue.use(BreadcrumbItem);
Vue.use(Card);Vue.use(Table);Vue.use(TableColumn);Vue.use(Pagination);Vue.use(Dialog);Vue.use(Upload);
Vue.use(Select);Vue.use(Option);Vue.use(Progress);Vue.use(Alert);Vue.use(Checkbox);Vue.use(CheckboxGroup);
Vue.use(Descriptions);Vue.use(DescriptionsItem);Vue.use(Result);Vue.use(Divider);Vue.use(Tag);
Vue.use(Tree);Vue.use(Scrollbar);Vue.use(Timeline);Vue.use(TimelineItem);Vue.use(Slider);Vue.use(Tabs);Vue.use(TabPane);
Vue.use(ColorPicker);Vue.use(Switch);Vue.use(Backtop);Vue.use(Tooltip);Vue.use(RadioButton);Vue.use(RadioGroup);Vue.use(Radio);
Vue.use(Image);Vue.use(Popconfirm)
const msgbox = MessageBox
const ElLoading = Loading
const { alert, confirm } = msgbox
Vue.prototype.$messageUi = Message
Vue.prototype.$loading = ElLoading
Vue.prototype.$notify = Notification
Vue.prototype.$alert = alert
Vue.prototype.$confirmUi = confirm
// Vue.prototype.$confirmUi = MessageBox.confirm
// Vue.prototype.$alert = MessageBox.alert
Vue.use(ElLoading.directive)
